'use client'

import React from 'react'

export function ChartTooltip({
  active,
  payload,
  label,
  isDark,
  labelMap,
}: {
  active?: boolean
  payload?: any[]
  label?: string
  isDark: boolean
  labelMap?: Record<string, string>
}) {
  if (!active || !payload?.length) return null
  return (
    <div
      className={`rounded border px-3 py-2 font-mono text-[11px] shadow-notice ${
        isDark
          ? 'border-border bg-card text-foreground'
          : 'border-border bg-card text-muted-foreground'
      }`}
    >
      <div className={`mb-1 font-semibold text-muted-foreground`}>
        {label}
      </div>
      {payload.map((p: any) => (
        <div key={p.dataKey} className="flex items-center gap-2">
          <span className="h-1.5 w-1.5 rounded-full" style={{ background: p.color }} />
          <span>{labelMap?.[p.dataKey] ?? p.dataKey}</span>
          <span
            className={`ml-auto pl-4 font-semibold ${
              'text-foreground'
            }`}
          >
            {p.value}
          </span>
        </div>
      ))}
    </div>
  )
}
